(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const media = window.matchMedia('(min-width: 769px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;

    const update = () => {
      ticking = false;
      const sections = document.querySelectorAll('[data-mj-soft-parallax="true"]');

      sections.forEach((section) => {
        if (!media.matches || reducedMotion.matches) {
          section.style.removeProperty('--mj-parallax-y');
          return;
        }

        const rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const clamped = Math.max(0, Math.min(1, progress));
        const offset = (clamped - 0.5) * 70;
        section.style.setProperty('--mj-parallax-y', `${offset.toFixed(1)}px`);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-atelier-header"]) return;
  try {
    
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const menu = document.querySelector('.ma-mobile-menu[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  }
});
document.addEventListener('click', function(event) {
  const menu = document.querySelector('.ma-mobile-menu[open]');
  if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
});

  } catch(e) { console.error(e); }
})();
})();
